import { FunctionComponent } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import CompanyDescription, { Types } from 'models/CompanyDescription';

import Button from 'components/layout/Button/component';
import LayoutContainer from 'components/layout/LayoutContainer';

import AboutUs from './blocks/AboutUs';
import Benefits from './blocks/Benefits';
import Gallery from './blocks/Gallery';
import Header from './blocks/Header';
import History from './blocks/History';
import Jobs from './blocks/Jobs';
import StagesDescripton from './blocks/StagesDescription';
import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJob: FunctionComponent<Props> = ({
    translations: {
        aboutUsTitle,
        galleryTitle,
        historyTitle,
        benefits,
        stagesTitle,
        jobs,
    },
    company,
    jobsList,
    isEditable,
}) => {
    const TypeFilter = (type: Types): CompanyDescription[] => Array.isArray(company?.companyDescriptions) && company.companyDescriptions
        .filter((desc: CompanyDescription) => desc.description.type === type)
        .sort((a, b) => a.description.order - b.description.order)
        || null;

    const companyAboutUs = TypeFilter(Types.About);
    const companyHistory = TypeFilter(Types.History);
    const { publicRuntimeConfig } = getConfig();
    const router = useRouter();
    return (
        <StyledComponent className="public-page-company-site-section-company">
            <LayoutContainer className="company-site-content">
                <Header
                    company={company}
                    isEditable={isEditable}
                />
                {companyAboutUs && companyAboutUs?.length > 0 && (
                    <AboutUs
                        title={aboutUsTitle}
                        descriptions={companyAboutUs}
                    />
                )}
                {company?.companyImages && company?.companyImages?.length > 0 && (
                    <Gallery
                        title={galleryTitle}
                        images={company?.companyImages}
                    />
                )}
                {companyHistory && companyHistory?.length > 0 && (
                    <History
                        title={historyTitle}
                        history={companyHistory}
                    />
                )}
                {company?.companyBenefits && company?.companyBenefits?.length > 0 && (
                    <Benefits
                        {...benefits}
                        benefits={company?.companyBenefits}
                    />
                )}
                {company?.stagesDescription && (
                    <StagesDescripton
                        title={stagesTitle}
                        stages={company?.stagesDescription}
                    />
                )}
                {jobsList?.length > 0 && (
                    <Jobs
                        {...jobs}
                        jobs={jobsList}
                    />
                )}
                {isEditable && (
                    <>
                        <div className='button-edit'>
                            <Button
                                onClick={() => {
                                    router.push(publicRuntimeConfig.COMPANY_PANEL_URL + Routes.CompanySite);
                                }}
                            >
                        Edytuj stronę
                            </Button>
                        </div>
                        <div className='mobile-button-edit'>
                            <Button
                                onClick={() => {
                                    router.push(publicRuntimeConfig.COMPANY_PANEL_URL + Routes.CompanySite);
                                }}
                            >
                        Edytuj stronę
                            </Button>
                        </div>
                    </>
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJob;
